/* ============================================================
   section-faq-accordion.js
   Accordion toggle for .faq__list sections.
   - One item open at a time (closes others in same list)
   - First item rendered open by the server; JS keeps it in sync
   ============================================================ */

function initAllFaqSections() {
  function initFaqList(list, triggerSelector, itemSelector, openClass) {
    var triggers = list.querySelectorAll(triggerSelector);
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var isOpen   = trigger.getAttribute('aria-expanded') === 'true';
        var answerId = trigger.getAttribute('aria-controls');
        var answer   = document.querySelector('[id="' + answerId + '"]');
        var item     = trigger.closest(itemSelector);

        if (isOpen) {
          trigger.setAttribute('aria-expanded', 'false');
          if (answer) answer.setAttribute('hidden', '');
          if (item)   item.classList.remove(openClass);
        } else {
          triggers.forEach(function (other) {
            if (other === trigger) return;
            var otherAnswer = document.querySelector('[id="' + other.getAttribute('aria-controls') + '"]');
            var otherItem   = other.closest(itemSelector);
            other.setAttribute('aria-expanded', 'false');
            if (otherAnswer) otherAnswer.setAttribute('hidden', '');
            if (otherItem)   otherItem.classList.remove(openClass);
          });
          trigger.setAttribute('aria-expanded', 'true');
          if (answer) answer.removeAttribute('hidden');
          if (item)   item.classList.add(openClass);
        }
      });
    });
  }

  document.querySelectorAll('[data-faq-list]').forEach(function (list) {
    initFaqList(list, '.faq__trigger', '.faq__item', 'faq__item--open');
  });

  document.querySelectorAll('.faq-section__items').forEach(function (list) {
    initFaqList(list, '.faq-section__trigger', '.faq-section__item', 'faq-section__item--open');
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllFaqSections);
} else {
  initAllFaqSections();
}